import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

export default function ParcelasTab({ parcelas, setParcelas }) {
  const [editIndex, setEditIndex] = useState(-1);

  const [formParcela, setFormParcela] = useState({
    dataVencimento: '',
    valor: '',
    descontoFinanceiro: ''
  });

  // Atualiza campos do form
  const handleChangeForm = (field, value) => {
    setFormParcela((prev) => ({ ...prev, [field]: value }));
  };

  // Adicionar ou atualizar parcela
  const handleAddOrUpdate = () => {
    if (!formParcela.dataVencimento) {
      alert('Informe a data de vencimento!');
      return;
    }
    if (!formParcela.valor) {
      alert('Informe o valor da parcela!');
      return;
    }

    if (editIndex >= 0) {
      // Atualizando
      const newArray = [...parcelas];
      newArray[editIndex] = { ...formParcela };
      setParcelas(newArray);
      setEditIndex(-1);
    } else {
      // Adicionando
      setParcelas([...parcelas, { ...formParcela }]);
    }

    // Limpa
    setFormParcela({
      dataVencimento: '',
      valor: '',
      descontoFinanceiro: ''
    });
  };

  const handleCancelEdit = () => {
    setEditIndex(-1);
    setFormParcela({
      dataVencimento: '',
      valor: '',
      descontoFinanceiro: ''
    });
  };

  // Editar
  const handleEdit = (index) => {
    setEditIndex(index);
    setFormParcela(parcelas[index]);
  };

  // Excluir
  const handleDelete = (index) => {
    if (window.confirm('Deseja excluir esta parcela?')) {
      setParcelas(parcelas.filter((_, i) => i !== index));
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Parcelas
      </Typography>

      {/* Formulário de parcelas */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Data Vencimento"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={formParcela.dataVencimento}
              onChange={(e) => handleChangeForm('dataVencimento', e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              label="Valor"
              variant="outlined"
              fullWidth
              type="number"
              value={formParcela.valor}
              onChange={(e) => handleChangeForm('valor', e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              label="Desconto Financeiro"
              variant="outlined"
              fullWidth
              type="number"
              value={formParcela.descontoFinanceiro}
              onChange={(e) => handleChangeForm('descontoFinanceiro', e.target.value)}
            />
          </Grid>
        </Grid>

        <Box mt={2}>
          <Button
            variant="contained"
            onClick={handleAddOrUpdate}
            sx={{ mr: 2 }}
          >
            {editIndex >= 0 ? 'Atualizar Parcela' : 'Adicionar Parcela'}
          </Button>
          {editIndex >= 0 && (
            <Button variant="contained" color="error" onClick={handleCancelEdit}>
              Cancelar Edição
            </Button>
          )}
        </Box>
      </Paper>

      {/* Tabela de parcelas */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: '#f8f8f8' }}>
            <TableRow>
              <TableCell># Parcela</TableCell>
              <TableCell>Data Vencimento</TableCell>
              <TableCell>Valor (R$)</TableCell>
              <TableCell>Desconto</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Excluir</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parcelas.map((parcela, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{parcela.dataVencimento}</TableCell>
                <TableCell>{parcela.valor}</TableCell>
                <TableCell>{parcela.descontoFinanceiro}</TableCell>
                <TableCell align="center">
                  <IconButton color="primary" onClick={() => handleEdit(index)}>
                    <Edit />
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton color="error" onClick={() => handleDelete(index)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {parcelas.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Nenhuma parcela adicionada.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
